import MortalityDistribution from "@/modules/MortalityDistribution/pages/MortalityDistribution"

export default [
	{
		path: '/ditribuicaoMortalidade',
		name: 'ditribuicaoMortalidade',
		component: MortalityDistribution
	}
];
